import React from "react";
import Squish_Photo from "../assets/Squish_Cover.png";
import Bunny_Photo from "../assets/bunny-thumbnail.png";
import BatteryLife_Photo from "../assets/Battery_Life_Cover.png";

const Portfolio = () => {
  return (
    <div
      name="portfolio"
      className="bg-gradient-to-b from-black to-gray-800 w-full text-white md:h-screen"
    >
      <div className="max-w-screen-lg px-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Portfolio
          </p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {/* Game 1 */}
          <div className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={Squish_Photo}
              alt="Squish Game Thumbnail"
              className="rounded-md duration-200 hover:scale-105 w-full h-64 object-cover"
            />
            <div className="flex items-center justify-center">
              <a
                href="https://chris-fung-dev.itch.io/squish"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="px-4 py-2 m-4 bg-blue-500 rounded-md text-white hover:bg-blue-700 duration-200">
                  Open
                </button>
              </a>
            </div>
          </div>
          {/* Game 2 */}
          <div className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={Bunny_Photo}
              alt="Bunny Game Thumbnail"
              className="rounded-md duration-200 hover:scale-105 w-full h-64 object-cover"
            />
            <div className="flex items-center justify-center">
              <a
                href="https://chris-fung-dev.itch.io/tiny-toy-tower"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="px-4 py-2 m-4 bg-blue-500 rounded-md text-white hover:bg-blue-700 duration-200">
                  Open
                </button>
              </a>
            </div>
          </div>
          {/* Game 3 */}
          <div className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={BatteryLife_Photo}
              alt="Battery Life Game Thumbnail"
              className="rounded-md duration-200 hover:scale-105 w-full h-64 object-cover"
            />
            <div className="flex items-center justify-center">
              <a
                href="https://chris-fung-dev.itch.io/battery-life"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="px-4 py-2 m-4 bg-blue-500 rounded-md text-white hover:bg-blue-700 duration-200">
                  Open
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
